////////////////////////////////////
// cinematicflow.js               //
// Copyright 2019 by Lazpace Inc. //
////////////////////////////////////

jQuery(function () {
  var today = new Date();
  var strWeddindDate;
  var strDeliveryDate;

  jQuery('#hirouen').datepicker({
    firstDay: 0,
    changeYear: true,
    changeMonth: true,
    yearRange: '2019:2030',
    dateFormat: 'yy/mm/dd',
    dayNamesMin: ['日', '月', '火', '水', '木', '金', '土'],
    monthNames: [
      '1月',
      '2月',
      '3月',
      '4月',
      '5月',
      '6月',
      '7月',
      '8月',
      '9月',
      '10月',
      '11月',
      '12月',
    ],
    monthNamesShort: [
      '1月',
      '2月',
      '3月',
      '4月',
      '5月',
      '6月',
      '7月',
      '8月',
      '9月',
      '10月',
      '11月',
      '12月',
    ],
    minDate: today,
    showOn: 'both',
    buttonText: '計算する',
    onSelect: function (dateText, inst) {
      strWeddindDate = dateText;
      setDelivery();
    },
  });

  function setDelivery() {
    var wd = new Date(strWeddindDate);
    var wtermDay = Math.ceil((wd - today) / 86400000);
    //var strSozaiDate = addDate(today, +1);
    var md = addDate(strWeddindDate, -3);

    if (wtermDay <= 2) {
      jQuery('div.sugi').css({ display: 'block' });
      jQuery('div.oisogi').css({ display: 'block' });
      jQuery('div.tujo').css({ display: 'none' });
      jQuery('div.tujonouhin').css({ display: 'none' });
      jQuery('#dnouhin').html('');
      jQuery('#lsozai').html('');
      jQuery('#dsozai').html('');
      jQuery('#lkakunin').html('');
      jQuery('#dkakunin').html('');
      jQuery('#lshiharai').html('');
      jQuery('#dshiharai').html('');
      jQuery('#lotodoke').html('');
      jQuery('#dotodoke').html('');
    } else {
      jQuery('div.sugi').css({ display: 'none' });
      jQuery('div.tujo').css({ display: 'block' });
      jQuery('div.oisogi').css({ display: 'none' });
      jQuery('div.tujonouhin').css({ display: 'block' });
      //jQuery("#lsozai").html("素材提供予定日:");
      jQuery('#dsozai').html(
        "<p>素材到着期限<input type='text' name='date3' id='sozai' readonly='readonly'>まで</p>"
      );

      if (wtermDay >= 30) {
        strDeliveryDate = addDate(strWeddindDate, -7);
        strSozaiDate = addDate(strDeliveryDate, -21);
        jQuery('#sozai').val(strSozaiDate);
        judgement(strDeliveryDate);
      } else {
        strDeliveryDate = addDate(strWeddindDate, -3);
        strSozaiDate = addDate(strDeliveryDate, -21);
        jQuery('#sozai').val(strSozaiDate);
        judgement(strDeliveryDate);
      }
    }
  }

  function addDate(strDate, addDate) {
    var dt = new Date(strDate);
    dt.setDate(dt.getDate() + addDate);
    var y = dt.getFullYear();
    var m = ('00' + (dt.getMonth() + 1)).slice(-2);
    var d = ('00' + dt.getDate()).slice(-2);

    return y + '/' + m + '/' + d;
  }

  function judgement(strDeliveryDate) {
    var sd = new Date(strDeliveryDate);
    var dtermDay = Math.ceil((sd - today) / 86400000);
    var md = addDate(strWeddindDate, -3);
    var mk = addDate(kd, -1);
    jQuery('#nouhintitle').html('納品予定日（完成DVDお受取り日）');
    jQuery('#dnouhin').html(
      "<p><input type='text' name='date2' id='nouhin' readonly='readonly'></p>"
    );
    jQuery('#nouhin').val(strDeliveryDate);

    if (dtermDay >= 21) {
      //jQuery("#lkakunin").html("ムービーのご視聴日:");
      jQuery('#dkakunin').html(
        "<p><input type='text' name='date4' id='kakunin' readonly='readonly'>まで</p>"
      );
      var kd = addDate(strDeliveryDate, -7);
      jQuery('#kakunin').val(kd);
      //jQuery("#lshiharai").html("お支払い:");
      jQuery('#dshiharai').html(
        "<p><input type='text' name='date5' id='shiharai' readonly='readonly'>ごろ</p>"
      );
      var shd = addDate(strDeliveryDate, -3);
      jQuery('#shiharai').val(shd);
      //jQuery("#lotodoke").html("商品お届け:");
      jQuery('#dotodoke').html(
        "<p><input type='text' name='date5' id='otodoke' readonly='readonly'>まで</p>"
      );
      jQuery('#otodoke').val(strDeliveryDate);

      jQuery('#nouhin').datepicker({
        firstDay: 0,
        changeYear: true,
        changeMonth: true,
        yearRange: '2019:2030',
        dateFormat: 'yy/mm/dd',
        dayNamesMin: ['日', '月', '火', '水', '木', '金', '土'],
        monthNames: [
          '1月',
          '2月',
          '3月',
          '4月',
          '5月',
          '6月',
          '7月',
          '8月',
          '9月',
          '10月',
          '11月',
          '12月',
        ],
        monthNamesShort: [
          '1月',
          '2月',
          '3月',
          '4月',
          '5月',
          '6月',
          '7月',
          '8月',
          '9月',
          '10月',
          '11月',
          '12月',
        ],
        minDate: today,
        maxDate: md,
        showOn: 'both',
        buttonText: '納品日を変更',
        onSelect: function (dateText, inst) {
          strDeliveryDate = dateText;
          judgement(strDeliveryDate);
        },
      });
    } else {
      jQuery('div.sugi').css({ display: 'none' });
      jQuery('div.oisogi').css({ display: 'block' });
      jQuery('div.tujo').css({ display: 'none' });
      jQuery('div.tujonouhin').css({ display: 'block' });

      jQuery('#lsozai').html('');
      jQuery('#dsozai').html('');
      jQuery('#lkakunin').html('');
      jQuery('#dkakunin').html('');
      jQuery('#lshiharai').html('');
      jQuery('#dshiharai').html('');
      jQuery('#lotodoke').html('');
      jQuery('#dotodoke').html('');
      jQuery('#nouhin').datepicker({
        firstDay: 0,
        changeYear: true,
        changeMonth: true,
        yearRange: '2019:2030',
        dateFormat: 'yy/mm/dd',
        dayNamesMin: ['日', '月', '火', '水', '木', '金', '土'],
        monthNames: [
          '1月',
          '2月',
          '3月',
          '4月',
          '5月',
          '6月',
          '7月',
          '8月',
          '9月',
          '10月',
          '11月',
          '12月',
        ],
        monthNamesShort: [
          '1月',
          '2月',
          '3月',
          '4月',
          '5月',
          '6月',
          '7月',
          '8月',
          '9月',
          '10月',
          '11月',
          '12月',
        ],
        minDate: today,
        maxDate: md,
        showOn: 'both',
        buttonText: '納品日を変更する',
        onSelect: function (dateText, inst) {
          strDeliveryDate = dateText;
          //judgement(strDeliveryDate);
          setDelivery();
        },
      });
      jQuery('#nouhin').val(strDeliveryDate);
    }
  }

  jQuery('input[name="custom_customer[hiroenbi]"]').datepicker({
    firstDay: 0,
    changeYear: true,
    changeMonth: true,
    yearRange: '2019:2030',
    dateFormat: 'yy/mm/dd',
    dayNamesMin: ['日', '月', '火', '水', '木', '金', '土'],
    monthNames: [
      '1月',
      '2月',
      '3月',
      '4月',
      '5月',
      '6月',
      '7月',
      '8月',
      '9月',
      '10月',
      '11月',
      '12月',
    ],
    monthNamesShort: [
      '1月',
      '2月',
      '3月',
      '4月',
      '5月',
      '6月',
      '7月',
      '8月',
      '9月',
      '10月',
      '11月',
      '12月',
    ],
    minDate: today,
  });

  //cart
  jQuery('#chirouen').datepicker({
    firstDay: 0,
    changeYear: true,
    changeMonth: true,
    yearRange: '2019:2030',
    dateFormat: 'yy/mm/dd',
    dayNamesMin: ['日', '月', '火', '水', '木', '金', '土'],
    monthNames: [
      '1月',
      '2月',
      '3月',
      '4月',
      '5月',
      '6月',
      '7月',
      '8月',
      '9月',
      '10月',
      '11月',
      '12月',
    ],
    monthNamesShort: [
      '1月',
      '2月',
      '3月',
      '4月',
      '5月',
      '6月',
      '7月',
      '8月',
      '9月',
      '10月',
      '11月',
      '12月',
    ],
    minDate: today,
  });

  jQuery('#csozai').datepicker({
    firstDay: 0,
    changeYear: true,
    changeMonth: true,
    yearRange: '2019:2030',
    dateFormat: 'yy/mm/dd',
    dayNamesMin: ['日', '月', '火', '水', '木', '金', '土'],
    monthNames: [
      '1月',
      '2月',
      '3月',
      '4月',
      '5月',
      '6月',
      '7月',
      '8月',
      '9月',
      '10月',
      '11月',
      '12月',
    ],
    monthNamesShort: [
      '1月',
      '2月',
      '3月',
      '4月',
      '5月',
      '6月',
      '7月',
      '8月',
      '9月',
      '10月',
      '11月',
      '12月',
    ],
    minDate: today,
  });

  jQuery('input[name="custom_customer[ordertype]"]').change(function () {
    var result = jQuery(this).val();

    if (result == 'お見積り') {
      jQuery('#zipcode_row').css({ display: 'none' });
      jQuery('#address1_row').css({ display: 'none' });
      jQuery('#address2_row').css({ display: 'none' });
      jQuery('#address3_row').css({ display: 'none' });
      jQuery('#tel_row').css({ display: 'none' });
    } else {
      jQuery('#zipcode_row').css({ display: 'table-row' });
      jQuery('#address1_row').css({ display: 'table-row' });
      jQuery('#address2_row').css({ display: 'table-row' });
      jQuery('#address3_row').css({ display: 'table-row' });
      jQuery('#tel_row').css({ display: 'table-row' });
    }
  });
});
